import AboutPageShell from '@/components/landing/about-page-shell';

export default function AboutEducationalPhilosophy() {
    return (
        <AboutPageShell
            title="Educational Philosophy"
            description="See how Northeastern College frames quality education as both accessible and transformative for individuals and communities."
        >
            <div className="bg-card border-border relative overflow-hidden rounded-2xl border p-8 shadow-sm md:p-12">
                <div className="mb-8 text-center">
                    <h2 className="text-foreground mb-2 text-2xl font-bold">Educational Philosophy</h2>
                    <span className="inline-flex rounded-full bg-[#0A7A35]/10 px-4 py-1.5 text-sm font-bold tracking-wide text-[#0A7A35] uppercase">
                        NC Learning Principle
                    </span>
                </div>

                <div className="via-border mx-auto mb-8 h-px max-w-3xl bg-gradient-to-r from-transparent to-transparent" />

                <div className="text-muted-foreground mx-auto max-w-4xl space-y-5 text-center text-sm leading-relaxed md:text-left md:text-base">
                    <p>
                        Northeastern College believes that quality education should be affordable not only to those who are economically capable but
                        also to those who are economically insufficient.
                    </p>
                    <p>
                        Through quality education, its educands can break economic barriers, develop God-given potentials, attain maximum growth,
                        assume diversified social duties and responsibilities, and withstand the challenges along life&apos;s varied avenues.
                    </p>
                </div>
            </div>
        </AboutPageShell>
    );
}
